import Rails from '@rails/ujs'
import Cookie from 'js-cookie'

import NekoPlayer from './movie_player/neko_player'
import PlayerLogger from './movie_player/player_logger'
import SchedulePlayer from './schedule_player_timer'
import RecommendationContainer from './movie_player/recommendation_container'
import ProgressButton from './progress_button'

class App {
  constructor() {
    /** @private {HTMLElement} */
    this._openVideoModalButton = document.getElementById('open-video')

    /** @private {HTMLElement} */
    this._closeVideoModalButton = document.getElementById('close-video')

    /** @private {HTMLElement} */
    this._downloadButton = document.getElementById('download-button')

    /** @private {HTMLElement} */
    this._videoModal = document.getElementById('video-modal')

    /** @private {HTMLElement} */
    this._playerContainer = document.getElementById('player-container')

    /** @private {HTMLElement} */
    this._downloadPlay = document.getElementById('download_play')

    /** @private {HTMLElement} */
    this._downloadedPlay = document.getElementById('downloaded_play')


    /** @private {NekoPlayer} */
    this._moviePlayer = null

    /** @private {PlayDataSource} */
    this._playerDataSource = null

    /** @private {RecommendationContainer} */
    this._recommendationContainer = null

    /** @private {ProgressButton} */
    this._progressButton = null

    /** @private {Number} */
    this._sessionCheckInterval = null
  }

  async init() {
    if (!NekoPlayer.isBrowserSupported()) {
      console.log('Browser not supported!')
      return
    }

    // [TODO] NekoPlayer 側で持たせるか別途検討
    const renderer = new RecommendationContainer.Renderer()
    const recommendationContainer = new RecommendationContainer(renderer)
    if (recommendationContainer.hasRecommendationContents()) {
      recommendationContainer.load()
      recommendationContainer.hidden()
    }

    const url = new URL(document.location.href)
    const apiEnabled = Number(url.searchParams.get('apienabled')) === 1

    const playerDataSouce = new PlayDataSource()
    const moviePlayer = new NekoPlayer(this._playerContainer, playerDataSouce, apiEnabled)
    await moviePlayer.init()

    const playerLogger = new PlayerLogger(
      playerDataSouce.key, undefined, playerDataSouce.ticket
    )

    moviePlayer.addEvent(NekoPlayer.Events.DidLoadManifest, (player, error) => {
      if (error) {
        player.showErrorMessage(NekoPlayer.Error.parse(error))
        player.deleteAllEvents()
        player.hideControls()
        console.error(error)
        player.sendMessage('onError')
      } else {
        this.startCheckSession()
        player.sendMessage('onReady')
      }
    })
    moviePlayer.addEvent(NekoPlayer.Events.DidStartPlayback, (player) => {
      playerLogger.createTime()
      player.hidePosterImage()
      this._recommendationContainer.hidden()
    })
    moviePlayer.addEvent(NekoPlayer.Events.DidPausePlayback, (player) => {
      if (!player.isFinished) playerLogger.updateTime(player.currentTime)
    })
    moviePlayer.addEvent(NekoPlayer.Events.DidBeginSeeking, (player) => {
      player.hidePosterImage()
    })
    moviePlayer.addEvent(NekoPlayer.Events.DidFinishPlayback, (player) => {
      playerLogger.updateTime(player.currentTime)
      this._recommendationContainer.show()
    })
    moviePlayer.addEvent(NekoPlayer.Events.WillEnterFullscreen, (player) => {
      const navBar = document.getElementsByClassName('is-fixed-top')[0]
      navBar.style.display = 'none'
      const body = document.getElementsByTagName('body')[0]
      body.style.paddingTop = '0px'
      window.scrollTo(0, 0)
    })
    moviePlayer.addEvent(NekoPlayer.Events.DidExitFullscreen, (player) => {
      const navBar = document.getElementsByClassName('is-fixed-top')[0]
      navBar.style.display = ''
      const body = document.getElementsByTagName('body')[0]
      body.style.paddingTop = ''
    })
    moviePlayer.addEvent(NekoPlayer.Events.WillCloseWindow, (player) => {
      if (!player.isPausing) playerLogger.updateTime(player.currentTime)
    })
    moviePlayer.addEvent(NekoPlayer.Events.DidDownloadProgress, (player, content, progress) => {
      this._progressButton.progress = progress
    })
    moviePlayer.addEvent(NekoPlayer.Events.DidFinishDownload, (player, content) => {
      this._progressButton.finish()
      this._progressButton.icon = ProgressButton.Icon.CheckUnderlineCircle
      this._downloadPlay.classList.add('is-hidden')
      this._downloadedPlay.classList.remove('is-hidden')
    })
    moviePlayer.addEvent(NekoPlayer.Events.DidFailDownload, (player, error) => {
      console.error(error)
      this._progressButton.finish()
    })
    moviePlayer.addEvent(NekoPlayer.Events.DidKeyDown, (player, event) => {
      // プレイヤーが提供するキー操作を一部変更したいなどの場合、適宜バリデーション

      if (player.executeKeyEvent(event.key)) {
        event.preventDefault()
      } else {
        // プレイヤーが提供しないキー操作が必要な場合はこの辺りに記載
      }
    })
    moviePlayer.addEvent(NekoPlayer.Events.DidReceiveMessage, (player, event) => {
      const url = new URL(document.location.href)
      const origin = url.searchParams.get('origin')
      if (event.origin !== origin) {
        // URL パラメータで渡された Origin と異なっている場合はエラー
        // 更に厳格に Origin を検証する場合、brand.original_url などとの比較を行う
        console.error(`Invalid Origin`)
      } else {
        player.executeMessage(JSON.parse(event.data))
      }
    })

    this._moviePlayer = moviePlayer
    this._playerDataSource = playerDataSouce
    this._recommendationContainer = recommendationContainer

    if (this._downloadButton) {
      const content = await this._moviePlayer.storage.contentAtOriginalUri(this._playerDataSource.src)

      this._progressButton = new ProgressButton(this._downloadButton)
      this._progressButton.init()
      this._progressButton.icon = content ?
        ProgressButton.Icon.CheckUnderlineCircle : ProgressButton.Icon.Download
      if (content == null) {
        this._downloadPlay.classList.remove('is-hidden')
        this._downloadedPlay.classList.add('is-hidden')
      } else {
        this._downloadPlay.classList.add('is-hidden')
        this._downloadedPlay.classList.remove('is-hidden')
      }
      this._progressButton.addEvent('click', async (progressButton) => {
        const content = await this._moviePlayer.storage.contentAtOriginalUri(this._playerDataSource.src)
        if (content) {
          this._moviePlayer.storage.removeAtOriginalUri(this._playerDataSource.src)
          progressButton.icon = ProgressButton.Icon.Download
          this._downloadPlay.classList.remove('is-hidden')
          this._downloadedPlay.classList.add('is-hidden')
        } else {
          progressButton.start()
          this._moviePlayer.download(this._playerDataSource.src, { key: this._playerDataSource.key })
        }
      })
    }

    if (!playerDataSouce.isManagement && playerDataSouce.isSchedulePlay) {
      // 視聴者向け且つ、擬似ライブが有効な場合、SchedulePlayer にプレイヤーの制御を渡す

      const archiveUrl = playerDataSouce.playSettings.archive_url
      const schedulePlayer = new SchedulePlayer(moviePlayer, archiveUrl)
      schedulePlayer.start(
        playerDataSouce.currentTime,
        playerDataSouce.startAt,
        playerDataSouce.endAt,
        playerDataSouce.duration
      )
    } else if (playerDataSouce.isPlayable) {
      this._moviePlayer.load()
    } else {
      this._moviePlayer.deleteAllEvents()
      this._moviePlayer.hideControls()

      // 通常上映会で視聴が行えない場合、保存済みのデータを削除する
      if (NekoPlayer.isOfflinePlaySupported()) {
        const content = await this._moviePlayer.storage.findContent(content => {
          return content.appMetadata.key === this._playerDataSource.key
        })
        if (content) this._moviePlayer.storage.removeAtOfflineUri(content.offlineUri)
      }
    }
  }

  startCheckSession() {
    if (!this._sessionCheckInterval) {
      const checkSession = () => {
        Rails.ajax({
          url: document.location.pathname + '/touch' + (document.location.search || ''),
          type: "GET",
          error: (response, status, xhr) => {
            if (xhr.status === 401) {
              window.clearInterval(this._sessionCheckInterval)
              const signInPath = Cookie.get('sign_in_path')
              window.location.href = (signInPath ? signInPath : '/entrance') + '?message=session_limited'
            }
          }
        })
      }

      this._sessionCheckInterval = window.setInterval(() => {
        checkSession()
      }, 100000)

      // 初回呼び出し
      checkSession()
    }
  }
}

class PlayDataSource extends NekoPlayer.DataSource {
  constructor() {
    super()

    this._play = null
  }

  get isPlayable() { return this._play.is_playable }
  get isManagement() { return this._play.is_management || false }
  get src() { return this._play.src }
  get key() { return this._play.key }
  get ticket() { return this._play.ticket }
  get playSettings() { return this._play.play_settings }
  get drm() { return this._play.drm }
  get isSchedulePlay() { return this.playSettings ? this.playSettings.schedule_play : false }
  get isMultiView() { return this.playSettings ? this.playSettings.multi_view_points : false }
  get externalManifests() { return this._play.manifests }
  get currentTime() { return this._play.timestamp }
  get startAt() { return this._play.start_at }
  get endAt() { return this._play.end_at }
  get duration() { return this._play.duration }

  /**
   * @param {string} url
   * @returns {Promise<Object>}
   */
  static fetchPlayData(url = document.location.pathname) {
    return new Promise((resolve, reject) => {
      Rails.ajax({
        url: url + (document.location.search || ''),
        type: 'GET',
        dataType: 'json',
        success: (response, status, xhr) => {
          resolve(response)
        },
        error: (response, status, xhr) => {
          resolve(response)
        }
      })
    })
  }

  /**
   * @override
   */
  async init() {
    super.init()
    this._play = await PlayDataSource.fetchPlayData()
  }

  /**
   * @override
   */
  playerPosterImageUri(player) {
    return this._play.poster_image_url
  }

  /**
   * @override
   */
  async playerContentSrc(player) {
    if (NekoPlayer.isOfflinePlaySupported()) {
      const content = await player.storage.contentAtOriginalUri(this.src)
      return content && content.offlineUri || this.src
    }

    return this.src
  }

  /**
   * @override
   */
  playerConfigration(player) {
    const configration = {
      manifest: {
        dash: {
          initialSegmentLimit: 10000 // IMPORTANT (This must be set according to your total number of segments)
        }
      },
      drm: {
        servers: {
          'com.widevine.alpha': this._play.wv_token || undefined,
          'com.microsoft.playready': this._play.pr_token || undefined,
          'com.apple.fps.1_0': this._play.fp_token || undefined,
        },
        advanced: {
          'com.widevine.alpha': {
            'videoRobustness': 'SW_SECURE_CRYPTO',
            'audioRobustness': 'SW_SECURE_CRYPTO'
          },
          'com.apple.fps.1_0': {
            serverCertificate: this.serverCertificate
          }
        }
      },
      playRangeStart: this.playSettings.start_time
    }

    player.autoplay = this.playSettings.auto_play_enabled

    return configration
  }

  /**
   * @override
   */
  playerDownloadConfigration(player) {
    const configration = {
      offline: {
        /**
         * @param {shaka.extern.StoredContent} content
         * @param {numver} progress normalize value
         */
        progressCallback: (content, progress) => {
          player.trigger(NekoPlayer.Events.DidDownloadProgress, player, content, progress)
        },
        /**
         * @param {Shaka.extern.TrackList} tracks
         */
        trackSelectionCallback: (tracks) => {
          // [TODO]
          // 言語別にビデオトラックが存在する場合、
          // ダウンロード時に選択するか、あるいは全てダウンロードするかの検討が必要
          // text, image トラックは現状対応していないため、字幕・サムネイル対応時に検討が必要
          const maxBandwidthVideoTrack = tracks
            .filter(track => track.type === 'variant')
            .sort((a, b) => a.bandwidth - b.bandwidth)
            .pop()

          return [maxBandwidthVideoTrack]
        },
        usePersistentLicense: false
      }
    }

    return configration
  }

  /**
   * @override
   */
  playerUIConfigration(player) {
    const controlPanelElements = []
    if (this.playSettings.play_button_enabled) controlPanelElements.push('play_pause')
    if (this.playSettings.mute_button_enabled) controlPanelElements.push('mute')
    if (this.playSettings.volume_bar_enabled) controlPanelElements.push('volume')
    if (this.playSettings.time_duration_enabled) controlPanelElements.push('time_and_duration')
    controlPanelElements.push('spacer')
    if (this.playSettings.fullscreen_button_enabled) {
      const elementName = player.isSupportFullscreen ? 'fullscreen' : 'fullscreen_menu_button'
      controlPanelElements.push(elementName)
    }
    if (this.externalManifests.length !== 0) controlPanelElements.push('manifest_menu')
    if (this.isMultiView) controlPanelElements.push('multi_view_points_menu')
    if (this.playSettings.overflow_menu_enabled) controlPanelElements.push('overflow_menu')

    const configration = {
      controlPanelElements: controlPanelElements,
      overflowMenuButtons: this._getOverflowMenuButtons(),
      addBigPlayButton: this.playSettings.big_play_button_enabled,
      addSeekBar: this.playSettings.seek_bar_enabled && (!this.playSettings.schedule_play || this.isManagement)
    }

    if (controlPanelElements.length > 1) {
      player.showControls()
    } else {
      // スペーサのみ指定されている場合、コントローラ自体を非表示化
      player.hideControls()
    }

    return configration
  }

  /**
   * @returns {Array<string>}
   * @private
   */
  _getOverflowMenuButtons() {
    if (this.playSettings.schedule_play) {
      return ['captions', 'quality', 'language']
    } else {
      return ['captions', 'quality', 'language', 'playback_rate']
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const app = new App()
  app.init()
})
